'use client';
import classNames from 'classnames';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React from 'react';
import { Trans } from 'react-i18next';

import CTAButton from '~/shared/components/cta-button/cta-button';
import { PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';
import { useTypedTranslation } from '~/shared/hooks';

import './title-block.scss';

import titleBlockBg from '~/assets/title-block-bg.webp';

const TitleBlock = ({ lng }) => {
  const t = useTypedTranslation(['button', 'text', 'page']);
  const router = useRouter();

  return (
    <section className="title-block">
      <div className={classNames('container', 'title-block__title-block')}>
        <div className="title-block__container">
          <div className="title-block__container-block">
            <link itemProp="url" href={getLocaleLink(PAGE_NAMES.HOME, lng)} />
            <h1 itemProp="headline" className="title-block__title">
              <Trans ns="page" i18nKey="page.home.title" />
            </h1>
            <h2 className="title-block__title-block-title">
              <Trans
                ns="text"
                components={{
                  u: <span key="span1" />,
                  br: <br key="br1" />,
                }}
                i18nKey="text.will-help-you"
              />
              !
            </h2>
            <h3 className="title-block__title-block-sub-title">
              <Trans ns="text" components={{ br: <br key="br1" /> }} i18nKey="text.read-our-posts" />
            </h3>
            <div className="title-block__cta">
              <div>
                <CTAButton
                  onClick={() =>
                    router.push(
                      getLocaleLink(
                        getUrl({
                          link: PAGE_NAMES.BLOG,
                        }),
                        lng,
                      ),
                    )
                  }
                  content={t('button.go-to-blog')}
                />
              </div>
              <div className="title-block__cta-text">
                <Trans ns="text" components={{ br: <br key="br1" /> }} i18nKey="text.more-than-10-years-of-teach" />
              </div>
            </div>
          </div>
          <Image
            alt={t('text.more-than-10-years-of-teach')}
            title={t('text.more-than-10-years-of-teach')}
            src={titleBlockBg.src}
            width={778}
            height={717}
            loading="eager"
            priority
            sizes="(max-width: 768px) 310, (max-width: 1200px) 778, 778"
            className="title-block__background"
          />
          <div className={classNames('title-block__grey-line', 'title-block__grey-line1')} />
          <div className={classNames('title-block__grey-line', 'title-block__grey-line2')} />
          <div className={classNames('title-block__grey-line', 'title-block__grey-line3')} />
          <div className={classNames('title-block__grey-line', 'title-block__grey-line4')} />
          <div className={classNames('title-block__grey-line', 'title-block__grey-line5')} />
          <div className={classNames('title-block__grey-line', 'title-block__grey-line6')} />
          <div className={classNames('title-block__yellow-line', 'title-block__yellow-line1')} />
          <div className={classNames('title-block__yellow-line', 'title-block__yellow-line2')} />
          <div className={classNames('title-block__yellow-line', 'title-block__yellow-line3')} />
        </div>
      </div>
    </section>
  );
};

export default TitleBlock;
